import { useFeatureFlag } from 'utils/hooks/useFeatureFlag';
import { INSIGHTS_FIELD_NAMES } from '../../constants';
import { ConnectedFormField } from './ConnectedFormField';
import { DescribedCheckbox } from './DescribedCheckbox';
import { FormSection } from './FormSection';

const { SHOW_REVENUE, ENABLE_IMPROVED_TRACKING } = INSIGHTS_FIELD_NAMES;
const SHOW_IMPROVED_TRACKING_PROJECT_SETTING = 'ShowImprovedTrackingProjectSetting';

export const INSIGHTS_SECTION_TEXT = {
  sectionId: 'insights',
  sectionHeadingText: 'Insights',
  /** show revenue */
  showRevenueDescriptionText: 'Show revenue and purchase metrics instead of custom conversions',
  showRevenueLabelText: 'Show revenue',
  /** enable improved tracking */
  enableImprovedTrackingLabelText: 'Enable improved tracking',
  enableImprovedTrackingDescriptionText:
    'Enable improved link tracking for more accurate heatmaps and insights',
};

export const InsightsFormSection = () => {
  const isImprovedTrackingEnabled = useFeatureFlag(SHOW_IMPROVED_TRACKING_PROJECT_SETTING);

  return (
    <FormSection
      id={INSIGHTS_SECTION_TEXT.sectionId}
      data-test={`${INSIGHTS_SECTION_TEXT.sectionId}-form-section`}
      headingText={INSIGHTS_SECTION_TEXT.sectionHeadingText}
    >
      <ConnectedFormField name={SHOW_REVENUE}>
        <DescribedCheckbox
          DescriptionText={INSIGHTS_SECTION_TEXT.showRevenueDescriptionText}
          label={INSIGHTS_SECTION_TEXT.showRevenueLabelText}
          name={SHOW_REVENUE}
        />
      </ConnectedFormField>
      {isImprovedTrackingEnabled && (
        <ConnectedFormField name={ENABLE_IMPROVED_TRACKING}>
          <DescribedCheckbox
            label={INSIGHTS_SECTION_TEXT.enableImprovedTrackingLabelText}
            DescriptionText={INSIGHTS_SECTION_TEXT.enableImprovedTrackingDescriptionText}
            name={ENABLE_IMPROVED_TRACKING}
          />
        </ConnectedFormField>
      )}
    </FormSection>
  );
};
